// OneBoutiq — scripts propios (vanilla, sin librerias externas)
document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initComparador();
  initGaleriaProducto();
  initVariantesProducto();
  initContadores();
});

function initContadores() {
  var els = document.querySelectorAll('[data-ob-contador]');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.textContent = el.getAttribute('data-ob-contador-fin'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      obs.unobserve(entry.target);
      var el = entry.target;
      var fin = parseFloat(el.getAttribute('data-ob-contador-fin')) || 0;
      var sufijo = el.getAttribute('data-ob-contador-sufijo') || '';
      var duracion = 1400;
      var inicio = null;
      function paso(ts) {
        if (!inicio) inicio = ts;
        var progreso = Math.min((ts - inicio) / duracion, 1);
        var valor = Math.round(fin * (1 - Math.pow(1 - progreso, 3)));
        el.textContent = valor + sufijo;
        if (progreso < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { obs.observe(el); });
}

function initReveal() {
  var els = document.querySelectorAll('.ob-reveal, .ob-reveal-stagger');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('ob-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('ob-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.18, rootMargin: '0px 0px -60px 0px' });
  els.forEach(function (el) { obs.observe(el); });
}

function initComparador() {
  document.querySelectorAll('[data-ob-comparador]').forEach(function (wrap) {
    var handle = wrap.querySelector('[data-ob-comparador-handle]');
    var after = wrap.querySelector('[data-ob-comparador-after]');
    if (!handle || !after) return;
    var dragging = false;

    function setPos(clientX) {
      var rect = wrap.getBoundingClientRect();
      var pct = ((clientX - rect.left) / rect.width) * 100;
      pct = Math.max(2, Math.min(98, pct));
      after.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
      handle.style.left = pct + '%';
    }

    handle.addEventListener('pointerdown', function (e) {
      dragging = true;
      handle.setPointerCapture(e.pointerId);
    });
    handle.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      setPos(e.clientX);
    });
    handle.addEventListener('pointerup', function () { dragging = false; });
    wrap.addEventListener('click', function (e) {
      if (e.target === handle) return;
      setPos(e.clientX);
    });
  });
}

function initGaleriaProducto() {
  document.querySelectorAll('[data-ob-galeria]').forEach(function (galeria) {
    var main = galeria.querySelector('[data-ob-galeria-principal]');
    var thumbs = galeria.querySelectorAll('[data-ob-galeria-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (!full) return;
        main.style.opacity = '0';
        setTimeout(function () {
          main.src = full;
          main.style.opacity = '1';
        }, 140);
        thumbs.forEach(function (t) { t.classList.remove('ob-thumb-activo'); });
        thumb.classList.add('ob-thumb-activo');
      });
    });
  });
}

function initVariantesProducto() {
  document.querySelectorAll('[data-ob-producto-form]').forEach(function (form) {
    var dataEl = form.querySelector('[data-ob-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var selects = form.querySelectorAll('[data-ob-opcion]');
    var idInput = form.querySelector('input[name="id"]');
    var precioEl = form.querySelector('[data-ob-precio]');
    var compareEl = form.querySelector('[data-ob-precio-comparado]');
    var botonComprar = form.querySelector('[data-ob-boton-comprar]');

    function moneda(centavos) {
      return (centavos / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '€';
    }

    function actualizar() {
      var valores = [];
      selects.forEach(function (s) { valores.push(s.value); });
      var encontrada = variantes.find(function (v) {
        return v.options.every(function (opt, i) { return opt === valores[i]; });
      });
      if (!encontrada) return;
      idInput.value = encontrada.id;
      if (precioEl) precioEl.textContent = moneda(encontrada.price);
      if (compareEl) {
        if (encontrada.compare_at_price && encontrada.compare_at_price > encontrada.price) {
          compareEl.textContent = moneda(encontrada.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (botonComprar) {
        if (encontrada.available) {
          botonComprar.disabled = false;
          botonComprar.textContent = botonComprar.getAttribute('data-texto-disponible') || 'Añadir al carrito';
        } else {
          botonComprar.disabled = true;
          botonComprar.textContent = botonComprar.getAttribute('data-texto-agotado') || 'Agotado';
        }
      }
      if (encontrada.imagen) {
        var galeria = form.closest('.ob-producto-grid') ? form.closest('.ob-producto-grid').querySelector('[data-ob-galeria]') : document.querySelector('[data-ob-galeria]');
        if (galeria) {
          var principal = galeria.querySelector('[data-ob-galeria-principal]');
          if (principal && principal.src.indexOf(encontrada.imagen.split('?')[0]) === -1) {
            principal.style.opacity = '0';
            setTimeout(function () {
              principal.src = encontrada.imagen;
              principal.style.opacity = '1';
            }, 140);
          }
          var thumbs = galeria.querySelectorAll('[data-ob-galeria-thumb]');
          thumbs.forEach(function (t) {
            var full = (t.getAttribute('data-full') || '').split('?')[0];
            var match = encontrada.imagen.split('?')[0];
            t.classList.toggle('ob-thumb-activo', full === match);
          });
        }
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', actualizar); });
    actualizar();
  });
}
